<template>
  <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4 sm:p-0"
       @keydown.esc="$emit('close')">
    <div
      class="bg-primary-bg dark:bg-primary-dark-bg p-6 sm:p-10 rounded-lg border border-light-border dark:border-dark-border w-full max-w-md sm:max-w-2xl max-h-[90vh] overflow-y-auto custom-scroll relative">
      <button @click="$emit('close')"
        class="absolute top-2 right-2 p-1 text-gray-400 hover:text-secondary-text dark:text-gray-300 dark:hover:text-white"
        tabindex="0">
        <XMarkIcon class="w-6 h-6" />
      </button>

      <h2
        class="flex items-center space-x-2 text-xl font-medium mb-4 border-b border-gray-300 text-primary-text dark:text-gray-100 pb-2">
        <span>{{ mode === 'create' ? 'Yeni Sipariş Ekle' : 'Sipariş Düzenle' }}</span>
      </h2>

      <label class="block mb-2 text-sm font-medium text-primary-text dark:text-gray-100">Bayi Seçiniz</label>
      <v-select v-model="selectedDealer" :options="vSelectDealers" 
        label="label"
        :reduce="dealer => dealer" 
        :disabled="!!dealerId || mode === 'edit'"   
        placeholder="Bayi Seçiniz"
        class=" w-full mb-4 border-light-border dark:border-dark-border bg-primary-bg dark:bg-gray-800 text-primary-text dark:text-gray-100"
        :filterable="true" 
        :searchable="true" 
        :clearable="true"
        @search="onDealerSearch"
        @update:modelValue="onDealerChange" />

      <label class="block mb-2 text-sm font-medium text-primary-text dark:text-gray-100">Kategori Seçiniz</label>
      <v-select v-model="form.category_id" :options="categories" label="category_name"
        :reduce="category => category.category_id"   :disabled="mode === 'edit'"  placeholder="Kategori Seçiniz"
        class="  w-full mb-4 border-light-border dark:border-dark-border bg-primary-bg dark:bg-gray-800 text-primary-text dark:text-gray-100"
        @update:modelValue="onCategoryChange" />

      <label class="block mb-2 text-sm font-medium text-primary-text dark:text-gray-100">Ürün Seçiniz</label>
      <v-select v-model="form.product_id" :options="filteredProducts" label="name" :reduce="product => product.id"
        placeholder="Ürün Seçiniz"
          :disabled="mode === 'edit'" 
        class=" w-full mb-4 border-light-border dark:border-dark-border bg-primary-bg dark:bg-gray-800 text-primary-text dark:text-gray-100"
        :filterable="true" :searchable="true" :clearable="true" 
        @update:modelValue="onProductChange" />

      <label class="block mb-2 text-sm font-medium text-primary-text dark:text-gray-100">Miktar (Tonaj)</label>
      <input v-model="form.amount" type="number" step="0.01" placeholder="Miktar"
        class="w-full p-2 mb-4 border rounded border-light-border dark:border-dark-border bg-primary-bg dark:bg-gray-800 text-primary-text dark:text-gray-100" 
        tabindex="0" />

      <!-- <button type="button" @click="form.ordered_products.push({ product_id: null, amount: null })"
        class="text-blue-500 mt-1 mb-6 text-sm">+ Ürün Ekle</button> -->

      <!-- <label class="block mb-2 text-sm font-medium text-primary-text dark:text-gray-100">Tonaj</label>
      <input  type="number"
        class="w-full p-2 border rounded mb-4 border-light-border dark:border-dark-border bg-primary-bg dark:bg-gray-800 text-primary-text dark:text-gray-100" /> -->

      <label class="block mb-2 text-sm font-medium text-primary-text dark:text-gray-100">Sipariş Numarası</label>
      <input v-model="form.order_number" type="text"  :disabled="mode === 'edit'" 
        :class="[
          'w-full p-2 border rounded mb-1 bg-primary-bg dark:bg-gray-800 text-primary-text dark:text-gray-100',
          fieldErrors.order_number ? 'border-red-500 dark:border-red-500' : 'border-light-border dark:border-dark-border'
        ]" 
        tabindex="0" />
     

      <button @click="handleSubmit"
        class="w-full bg-primary-button text-white py-2 px-4 mt-3 rounded hover:bg-primary-button-hover transition"
        tabindex="0">
        {{ mode === 'create' ? 'Siparişi Kaydet' : 'Siparişi Güncelle' }}
      </button>
    </div>
  </div>
</template>

<script>
import { getApi, postApi, putApi } from "@/services/api";
import { XMarkIcon } from '@heroicons/vue/24/outline';
import vSelect from 'vue3-select'
import 'vue3-select/dist/vue3-select.css'

export default {
  name: "OrderModal",
  components: {
    XMarkIcon,
    vSelect
  },
  props: {
    dealerId: {
      type: [String, Number],
      required: false,
    },
    mode: {
      type: String,
      default: 'create',
    },
    order: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dealers: [],
      categories: [],
      products: [],
      searchTimeout: null, 
      selectedDealer: null, 
      form: {
        dealer_id: null,
        order_id: null,
        order_number: null,
        product_id: null,
        amount: null,
        order_tonnage: null
      },
      fieldErrors: {
        order_number: null
      }
    };
  },
  computed: {
    activeDealers() {
      return this.dealers.filter(dealer => dealer.dealer_status === 1);
    },
    filteredProducts() {
      if (!this.form.category_id) return [];
      return this.products.filter(p => +p.category_id === +this.form.category_id);
    },
    vSelectDealers() {
      return this.dealers.map(dealer => ({
        label: dealer.dealer_name,
        value: dealer.dealer_id,
        ...dealer 
      }));
    }
  },
  watch: {
    order: {
      immediate: true,
      handler(newVal) {
        if (this.mode === 'edit' && newVal) {
          const productId = newVal.product_id || newVal.loadProducts?.[0]?.id || null;

          const matchedProduct = this.products.find(p => p.id === productId);
          const categoryId = matchedProduct?.category_id || null;

          this.form = {
            dealer_id: newVal.dealer_id || null,
            order_id: newVal.id || newVal.order_id || null,
            category_id: categoryId,
            product_id: productId,
            order_number: newVal.order_number || newVal.orderNumber || '',
            amount: newVal.amount || newVal.totalTonnage || null,
            order_tonnage: newVal.amount || newVal.totalTonnage || null
          };
        }
      }
    },
    mode: {
      immediate: true,
      handler(newVal) {
        if (newVal === 'create' && this.dealerId) {
          this.form.dealer_id = this.dealerId;
        }
      }
    }
  },
  methods: {
    resetForm() {
    this.form = {
      dealer_id: null,
      order_id: null,
      order_number: null,
      product_id: null,
      amount: null,
      order_tonnage: null
    };
  },

    async fetchData() {
      try {
        const categories = await getApi('/categories/');
        this.categories = categories;
        this.products = []; 

      } catch (error) {
        this.$toast.error("Veriler yüklenirken hata oluştu!");
      }
    },

    async fetchProductsByCategory(categoryId) {
      if (!categoryId) {
        this.products = [];
        return;
      }
      
      try {
        const response = await getApi(`/products/category/${categoryId}`);
        this.products = response || [];
      } catch (error) {
        this.products = [];
      }
    },

    onDealerSearch(searchTerm) {
      const cleanTerm = searchTerm?.trim() || '';
      
      if (cleanTerm.length < 2) {
        this.dealers = [];
        return;
      }
      
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      
      this.searchTimeout = setTimeout(() => {
        this.fetchDealers(cleanTerm);
      }, 300); 
    },

    async fetchDealers(searchTerm) {
      try {
        const response = await getApi(`/dealers/search?q=${encodeURIComponent(searchTerm)}`);
        this.dealers = response || [];
        
      } catch (error) {
        console.error('Bayi arama hatası:', error);
        this.dealers = [];
        if (error.response?.status === 500) {
          this.$toast.error("Arama sırasında sunucu hatası oluştu");
        } else if (error.response?.status === 400) {
          this.$toast.error("Arama sorgusu çok kısa");
        } else {
          this.$toast.error("Bayi arama sırasında hata oluştu");
        }
      }
    },

    onDealerChange(selectedDealer) {
      this.selectedDealer = selectedDealer;
      
      if (selectedDealer) {
        this.form.dealer_id = selectedDealer.value;
      } else {
        this.form.dealer_id = null;
      }
      
      this.$nextTick(() => {
        const categorySelect = this.$el.querySelector('.v-select:nth-of-type(2)');
        if (categorySelect) {
          const input = categorySelect.querySelector('input');
          if (input) input.focus();
        }
      });
    },

    onCategoryChange(categoryId) {
      this.form.product_id = null; 
      this.fetchProductsByCategory(categoryId);
      
      this.$nextTick(() => {
        const productSelect = this.$el.querySelector('.v-select:nth-of-type(3)');
        if (productSelect) {
          const input = productSelect.querySelector('input');
          if (input) input.focus();
        }
      });
    },

    onProductChange() {
      this.$nextTick(() => {
        const amountInput = this.$el.querySelector('input[type="number"]');
        if (amountInput) amountInput.focus();
      });
    },

    async handleSubmit() {
      try {
        this.fieldErrors.order_number = null;
        if (!this.form.dealer_id || !this.form.product_id || !this.form.amount) {
          this.$toast.error("Lütfen bayi, ürün ve miktar bilgilerini doldurun.");
          return;
        }
        const createPayload  = {
          dealer_id: this.form.dealer_id,
          product_id: this.form.product_id,
          order_tonnage: Number(String(this.form.amount).replace(',', '.')),
          order_number: this.form.order_number,
          order_time: new Date().toISOString(),
        };

        if (this.mode === 'edit') {
             const editPayload = {
        dealer_id: this.form.dealer_id, 
        order_tonnage: Number(String(this.form.amount).replace(',', '.')),

      };
          await putApi(`/orders/id/${this.form.order_id}`, editPayload);
        } else {
          await postApi('/orders/', createPayload );
        }

        this.$emit('submit');
        this.$toast.success("Sipariş başarıyla kaydedildi!");
        this.resetForm();
        this.$emit('close');

      } catch (error) {
        const backendMessage = error?.response?.data?.detail;
        if (backendMessage) {
          this.$toast.error(backendMessage);
          if (typeof backendMessage === 'string' && backendMessage.toLowerCase().includes('sipariş numarası')) {
            this.fieldErrors.order_number = backendMessage;
          }
        } else {
          this.$toast.error("Sipariş kaydedilirken bir hata oluştu!");
        }
      }
    },

    handleKeydown(event) {
      if (event.key === 'Escape') {
        this.$emit('close');
      }
      
      if (event.key === 'Tab') {
        const focusableElements = this.$el.querySelectorAll(
          'button, input, .v-select, [tabindex]:not([tabindex="-1"])'
        );
        
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        
        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      }
    },
  },
  async mounted() {
    await this.fetchData();

    if (this.mode === 'edit' && this.order) {
      this.$watch('order', this.$options.watch.order.handler.bind(this));
      this.$options.watch.order.handler.call(this, this.order);
    }

    document.addEventListener('keydown', this.handleKeydown);
  },

  beforeUnmount() {
    document.removeEventListener('keydown', this.handleKeydown);
  }

  

};
</script>